import * as React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HistoricalComparisonFilter } from './HistoricalComparisonFilter';

export const HistoricalComparisonFilterDialog = (props: any) => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(props.open ?? false);
    const [dialogSubmit, setDialogSubmit] = React.useState(0);

    const handleClose = () => {
        setOpen(false);
        props.onChangeOpen(false);
    };

    const handleSubmit = () => {
        setDialogSubmit(dialogSubmit + 1);
    }

    React.useEffect(() => {
        if (props.open !== open)
        {
            setOpen(props.open);
        }
    }, [props.open, open]);

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{display: open ? 'block' : 'none'}}
        >
            <DialogTitle id="alert-dialog-title">
                {t("Date Selection")}
            </DialogTitle>
            <DialogContent>
                <HistoricalComparisonFilter
                    dialogSubmit={dialogSubmit}
                    chartType={props.chartType}
                    defaultValues={props.defaultValues}
                    onSubmit={(values: any) => {
                        props.onSubmit(values);
                        handleClose();
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('Cancel')}</Button>
                <Button variant="contained" onClick={handleSubmit} data-cy-id="historicalComparisonFilter-cancelButton">{t('Filter')}</Button>
            </DialogActions>
      </Dialog>
    );
};